import React from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { compose, lifecycle, withState } from 'recompose'
import styled from 'styled-components'

import EmployerImg from 'assets/images/employer.png'
import { EMPLOYER_LOGO, EMPLOYER_LOGO_DEFAULT } from 'utils/testing/testIDs'

type Props = {
  src: string
}

type StateProps = {
  hasError: boolean
  setHasError: (hasError: boolean) => void
}

type InnerProps = Props & StateProps

const LogoImg = styled.img`
  width: 32px;
  margin-right: 17px;
`

const LogoObj = styled.object`
  width: 32px;
  margin-right: 17px;
`

export const Logo = (props: InnerProps) => (
  <>
    {!props.hasError && props.src ? (
      <LogoObj
        data={`${props.src}?size=128`}
        type="image/png"
        data-testid={EMPLOYER_LOGO}
      >
        <LogoImg src={EmployerImg} alt="Employer Logo" />
      </LogoObj>
    ) : (
      <LogoImg
        src={EmployerImg}
        alt="Employer Logo"
        data-testid={EMPLOYER_LOGO_DEFAULT}
      />
    )}
  </>
)

export const enhance = compose<InnerProps, Props>(
  withState('hasError', 'setHasError', false),
  lifecycle({
    componentDidCatch(error) {
      datadogRum.addError(error)
      this.props.setHasError(true)
    },
  }),
)

export default enhance(Logo)
